import CarThumbnailSliderContainer from "../../../components/car/detail/CarThumbnailSlider";

const CarThumbnailSlider = () => {
  return <CarThumbnailSliderContainer />;
};

export default CarThumbnailSlider;
